import type { SVGProps } from 'react';
export const IconKitMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 8.01013C13.6234 6.88356 11.9933 6.11035 10.251 5.75755C9.89793 4.01144 9.12438 2.37823 7.9975 1C6.87401 2.37977 6.10239 4.01249 5.74899 5.75755C4.00671 6.11035 2.3766 6.88356 1 8.01013C2.3766 9.13662 4.00671 9.90983 5.74899 10.2626C6.10449 12.0009 6.87611 13.6266 7.9975 15C9.12535 13.6224 9.89915 11.9889 10.251 10.2425C11.9933 9.88965 13.6234 9.11644 15 7.98987"
      fill="currentColor"
    />
  </svg>
);
